export default "__VITE_ASSET__C5HArYXm__"